const BarnIcon = ({size = 22, color = "#61788B"}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.71363 5.3589L2.84716 7.32577C2.70098 7.65761 2.62788 7.82353 2.5908 7.99983C2.55371 8.17614 2.55371 8.35771 2.55371 8.72085V17.0087C2.55371 17.8183 2.55371 18.2232 2.80302 18.4747C3.05233 18.7262 3.45358 18.7262 4.25609 18.7262H16.1728C16.9753 18.7262 17.3765 18.7262 17.6258 18.4747C17.8751 18.2232 17.8751 17.8183 17.8751 17.0087V8.37341C17.8751 7.9698 17.8751 7.76799 17.8296 7.57337C17.7841 7.37874 17.6946 7.19824 17.5157 6.83724L16.7305 5.25296C16.4546 4.69616 16.3166 4.41775 16.0969 4.20874C15.8772 3.99973 15.5936 3.87712 15.0264 3.63189L11.5556 2.13121C10.8944 1.84533 10.5639 1.70239 10.2144 1.70239C9.865 1.70239 9.53441 1.84533 8.87322 2.13121L5.48374 3.59674C4.87724 3.85898 4.57398 3.99009 4.3448 4.21824C4.11563 4.44639 3.98163 4.75056 3.71363 5.3589Z"
        stroke={color}
        stroke-width="1.27679"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.41699 20.1665V11.9165M15.5837 11.9165V20.1665"
        stroke={color}
        stroke-width="1.27679"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.41699 11.9165L15.5837 20.1665M6.41699 20.1665L15.5837 11.9165"
        stroke={color}
        stroke-width="1.27679"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.75 11.9165H19.25"
        stroke={color}
        stroke-width="1.27679"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0003 9.16667C12.0128 9.16667 12.8337 8.34586 12.8337 7.33333C12.8337 6.32081 12.0128 5.5 11.0003 5.5C9.9878 5.5 9.16699 6.32081 9.16699 7.33333C9.16699 8.34586 9.9878 9.16667 11.0003 9.16667Z"
        stroke={color}
        stroke-width="1.27679"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BarnIcon;
